import { cloneDeep, remove } from "lodash";

const initialState = {
  staff: null,
  totalPages: 0,
  ownerAccount: {},
  closeModal: false,
  savingStaff: false,
  changingStatus: false,
  updateError: null
};

const staffReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_STAFF':
      return {
        ...state,
        staff: action.data.staff,
        totalPages: action.data.total_pages,
        ownerAccount: action.data.owner
      };
    case 'START_SAVING_STAFF_REQUEST':
      return {
        ...state,
        savingStaff: true
      };
    case 'END_SAVING_STAFF_REQUEST':
      return {
        ...state,
        savingStaff: false
      };
    case 'CREATE_STAFF': {
      const newStaffList = cloneDeep(state.staff);
      newStaffList.unshift(action.data.user);

      return {
        ...state,
        staff: newStaffList,
        closeModal: true
      };
    }
    case 'UPDATE_STAFF': {
      const { user } = action.data;

      return {
        ...state,
        staff: state.staff.map((item) => (item.id === user.id ? user : item)),
        closeModal: true,
        updateError: null
      };
    }
    case 'UPDATE_STAFF_ERROR': {
      return {
        ...state,
        updateError: action.error,
        closeModal: false
      };
    }
    case 'CLEAR_STAFF_ERROR': {
      return {
        ...state,
        updateError: null
      };
    }
    case 'TOGGLE_MANAGE_STAFF_MODAL':
      return {
        ...state,
        closeModal: action.data.toggle
      };
    case 'REMOVE_AGENT_FROM_STAFF_LIST': {
      const newStaffList = remove(state.staff, (item) => item.id !== action.data.user.id);

      return {
        ...state,
        staff: newStaffList
      };
    }
    case 'START_TOGGLE_AVAILABILITY_REQUEST':
      return {
        ...state,
        changingStatus: true
      };
    case 'END_TOGGLE_AVAILABILITY_REQUEST':
      return {
        ...state,
        changingStatus: false
      };
    default:
      return state;
  }
};

export default staffReducer;
